import React from 'react';

import Avatar from '@atlaskit/avatar';

const AvatarStatusLockedExample = (): React.JSX.Element => {
	return <Avatar name="John Smith" status="locked" />;
};

export default AvatarStatusLockedExample;
